(function() {
  const section = document.querySelector('.service-callouts');
  if (!section) return;
  const ticker = section.querySelector('.service-callouts__ticker');
  const track = section.querySelector('.service-callouts__track');
  const prevBtn = section.querySelector('.service-callouts__arrow--prev');
  const nextBtn = section.querySelector('.service-callouts__arrow--next');
  if (!ticker || !track || !prevBtn || !nextBtn) return;

  /* Reduced-motion: show arrows, enable manual scroll */
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)');

  function handleMotionPref() {
    if (mq.matches) {
      prevBtn.addEventListener('click', scrollPrev);
      nextBtn.addEventListener('click', scrollNext);
    }
  }

  function scrollPrev() {
    ticker.scrollBy({ left: -300, behavior: 'smooth' });
  }
  function scrollNext() {
    ticker.scrollBy({ left: 300, behavior: 'smooth' });
  }

  /* Pause animation on hover/focus */
  ticker.addEventListener('mouseenter', function() {
    track.style.animationPlayState = 'paused';
  });
  ticker.addEventListener('mouseleave', function() {
    if (!mq.matches) track.style.animationPlayState = 'running';
  });

  /* Pause animation when off-screen to improve performance */
  if ('IntersectionObserver' in window) {
    var sectionEl = section || track.closest('.shopify-section');
    if (sectionEl) {
      new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          track.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
        });
      }, { threshold: 0.1 }).observe(sectionEl);
    }
  }

  handleMotionPref();
  mq.addEventListener('change', handleMotionPref);
})();
